<template>
    <div v-if="receipts && receipts.length > 0" class="shipment-receipts-display">
        <v-menu offset-y left>
            <template #activator="{ on, attrs }">
                <v-chip
                    small
                    color="primary"
                    outlined
                    class="shipment-receipts-display__chip"
                    v-bind="attrs"
                    v-on="on"
                >
                    {{ receipts.length }}
                    <v-icon small class="ml-1">mdi-receipt</v-icon>
                </v-chip>
            </template>
            <v-list dense class="shipment-receipts-display__menu">
                <v-list-item
                    v-for="(receipt, index) in receipts"
                    :key="receipt.id || index"
                    class="shipment-receipts-display__item"
                >
                    <v-list-item-content>
                        <v-list-item-title
                            class="shipment-receipts-display__amount"
                        >
                            {{ formatPrice(receipt.amount || 0) }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            <div class="shipment-receipts-display__details">
                                <span
                                    v-if="receipt.source"
                                    class="shipment-receipts-display__source"
                                >
                                    {{ receipt.source }}
                                </span>
                                <DateCell
                                    v-if="receipt.created_at"
                                    :value="receipt.created_at"
                                    :utc="false"
                                    format-type="dd-MM-yyyy"
                                />
                            </div>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action
                        v-if="receipt.rivhit_document_link"
                    >
                        <ShipmentDocumentLink
                            :link="receipt.rivhit_document_link"
                        />
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
    <span v-else>-</span>
</template>

<script>
import DateCell from '@/components/common/cells/date-cell.vue'
import ShipmentDocumentLink from '@/components/shipments/shipment-document-link.vue'

export default {
    name: 'ShipmentReceiptsDisplay',
    components: {
        DateCell,
        ShipmentDocumentLink,
    },
    props: {
        receipts: {
            type: Array,
            default: () => null,
        },
    },
    methods: {
        formatPrice(price) {
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(price)
        },
    },
}
</script>

<style lang="scss" scoped>
.shipment-receipts-display {
    display: flex;
    justify-content: center;

    &__chip {
        cursor: pointer;
    }

    &__menu {
        max-width: 300px;
        max-height: 400px;
        overflow-y: auto;
    }

    &__item {
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
            border-bottom: none;
        }
    }

    &__amount {
        font-weight: 600;
        font-size: 14px;
        color: #333;
    }

    &__details {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 4px;
    }

    &__source {
        font-size: 12px;
        color: #666;
        padding: 2px 6px;
        background: #f5f5f5;
        border-radius: 4px;
    }
}
</style>

